/* eslint-disable no-undef */

'use strict';

/**
 * @description create Subscription
 * @returns {void}
 */

module.exports = {
	createSubscription: function () {
		$(document).ready(function () {
			/**
			* Validates the format of an email address using a regular expression.
			*
			* @param {string} email - The email address to be validated.
			* @returns {boolean} - Returns true if the email address is in a valid format, otherwise false.
			*/
			function validateEmail(email) {
				var regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
				return regex.test(email);
			}

			/**
			 * @description Does a subscription call
			 * @param {string} email , subscriber email
			 */
			function sendSubscriptionRequest(email) {
				$.ajax({
					type: 'POST',
					url: CleverReachUrls.footerSubscription,
					data: { emailAddress: email, source: 'footer' },
					success: function (response) {
						if (typeof response === 'string') {
							try {
								const jsonString = response.match(/{[^}]*"success":\s*(true|false)[^}]*}/);
								if (jsonString) {
									const jsonResponse = JSON.parse(jsonString[0]);
									var isSuccess = jsonResponse.success;

									if (isSuccess) {
										window.location.href = CleverReachUrls.thankYouPage;
									} else if (jsonResponse.message) {
										$('.newsletter-form').addClass('error');
										$('.newsletter-form-error').html(jsonResponse.message);
									} else {
										window.location.href = CleverReachUrls.errorPage;
									}
								} else {
									window.location.href = CleverReachUrls.errorPage;
								}
							} catch (e) {
								window.location.href = CleverReachUrls.errorPage;
							}
						}
					},
					error: function () {
						window.location.href = CleverReachUrls.errorPage;
					}
				});
			}

			$('#cleverReach-newsletter-subscription button').on('click', function (e) {
				e.preventDefault();
				var email = $('#cleverReach-newsletter-subscription #email-alert-address').val();
				$('#cleverReach-newsletter-subscription').find('.newsletter-form.error').removeClass('error');
				if (email.length > 0) {
					if (validateEmail(email)) {
						sendSubscriptionRequest(email);
					} else {
						$(this).closest('.newsletter-form').addClass('error');
					}
				}
			});

			// Add a checkbox for privacy policy if cleverReach is enabled
			if (window.CleverReachPreferences.cleverReachEnabled && window.CleverReachPreferences.cleverReachEnabled !== false) {
				var elementBefore = '<input type="checkbox" class="input-checkbox privacy-checkbox" value="false" /> ' + window.CleverReachResources.privacyBeforeLink + ' ';
				var elementAfter = ' ' + window.CleverReachResources.privacyAfterLink;

				$('a.privacy-policy').parent().prepend(elementBefore).append(elementAfter);

				$('#dwfrm_billing').on('submit', function (event) {
					if ($(this).find('input.privacy-checkbox').prop('checked') === false) {
						event.preventDefault();
						$('input.privacy-checkbox').parent().addClass('error-privacy');
					} else {
						$('input.privacy-checkbox').parent().removeClass('error-privacy');
					}
				});
				$('#account_subscribe').on('click', function (event) {
					event.preventDefault();
					$('.email-signup-wrapper').slideDown(800);
				});
			}

		$('.layout_form.cr_form.cr_font').on('submit', function () {
			var firsName = $('#cr_form-input--text9217129').val();
			var lastName = $('#cr_form-input--text9217130').val();
			var email = $('#text9212792').val();

			if (firsName && lastName && email) {
				$.ajax({
					type: 'POST',
					url: CleverReachUrls.storefrontRegistrationForm
				});
			}
			});
		});
	}
};
